import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CompanyDetails } from '@store';

import { Invitation, UserV2, UserRoleType } from '@vi-iot/client';

import { GatewayInvitationsService } from '../../../+installations/installation/gateway-features-panel/gateway-invitations.service';
import { NO_VALUE } from '../../pipes/dash/dash.pipe';

@Component({
  selector: 'app-invitation-list-item',
  templateUrl: './invitation-list-item.component.html',
  styleUrls: ['./invitation-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationListItemComponent {
  statusFilters = this.gatewayInvitationsService.statusFilters;

  @Input()
  invitation: Invitation;

  @Input()
  inviter: UserV2;

  @Input()
  invitee: UserV2;

  @Input()
  inviteeCompany: CompanyDetails;

  @Input()
  inviterCompany: CompanyDetails;

  get inviterName(): string {
    return this.inviter
      ? `${this.inviter.name.firstName} ${this.inviter.name.familyName}`
      : NO_VALUE;
  }

  get inviteeName(): string {
    return this.invitee ? `${this.invitee.name.firstName} ${this.invitee.name.familyName}` : null;
  }

  get inviterCompanyName(): string {
    if (this.inviter?.iotRole?.toLocaleLowerCase() === UserRoleType.endUser.toLowerCase()) {
      return this.translation.instant('GATEWAY.INVITATION_LIST.END_CUSTOMER');
    }

    if (this.invitation?.inviterCompanyName) {
      return this.invitation.inviterCompanyName;
    }

    if (this.inviter?.company?.name) {
      return this.inviter.company.name;
    }

    return this.inviterCompany ? this.inviterCompany.companyName : NO_VALUE;
  }

  get inviteeCompanyName(): string {
    if (this.invitee?.iotRole.toLowerCase() === UserRoleType.endUser.toLowerCase()) {
      return this.translation.instant('GATEWAY.INVITATION_LIST.END_CUSTOMER');
    }

    if (this.invitation?.companyName) {
      return this.invitation.companyName;
    }

    if (this.invitee?.company?.name) {
      return this.invitee.company.name;
    }

    return this.inviteeCompany ? this.inviteeCompany.companyName : null;
  }

  get inviteeEmail(): string {
    return this.invitation && this.invitation.inviteeEmail
      ? this.invitation.inviteeEmail
      : NO_VALUE;
  }

  get statusName(): string {
    const filter = this.statusFilters.find(
      (statusFilter: { value: string; name: string }) =>
        statusFilter.value === this.invitation.status
    );

    return filter?.name;
  }

  constructor(
    private translation: TranslateService,
    private gatewayInvitationsService: GatewayInvitationsService
  ) {}
}
